import { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'pending' | 'in-progress' | 'approved' | 'rejected' | 'warning' | 'info' | 'default' | 'success' | 'destructive'
}

const Badge = ({ variant = 'default', className = '', children, ...props }: BadgeProps) => {
  const variants = {
    'default': 'bg-muted text-muted-foreground',
    'pending': 'bg-muted text-muted-foreground',
    'in-progress': 'bg-secondary text-secondary-foreground',
    'approved': 'bg-success/10 text-success',
    'success': 'bg-success/10 text-success',
    'rejected': 'bg-destructive/10 text-destructive',
    'destructive': 'bg-destructive/10 text-destructive',
    'warning': 'bg-warning/10 text-warning',
    'info': 'bg-accent text-accent-foreground',
  }
  
  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium",
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

export default Badge
